<template>
    <div class="homePage ">
        <img src="../../assets/image/bg.jpg" alt="">
        <div class="homePage-right">
            <span class="h3">
                {{$t("homePage.welcome")}}
            </span>
            <el-form :model="formData">
                <el-form-item label="" class="form-item-first">
                    <el-input v-model="formData.account" class="login-input"
                              :placeholder="$t('homePage.accountHolder')"
                              @input="formatUpper('formData','account',formData.account)">
                        <i slot="prefix" class="el-icon-s-custom icon"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-input v-model="formData.passWord" class="login-input"
                              show-password
                              :placeholder="$t('homePage.pwdHoder')"
                              @input="formatUpper('formData','passWord',formData.passWord)">
                        <i slot="prefix" class="el-icon-lock icon"></i>
                    </el-input>
                </el-form-item>
            </el-form>
            <p class="font-weight" style="font-size:14px">{{$t("homePage.forgetPassword")}}</p>
            <div class="login-row">
                <el-select v-model="formData.entity" class="entity-select" placeholder="请选择主体">
                    <i slot="prefix" class="el-icon-office-building icon"></i>
                    <el-option label="1-股份" value="1"></el-option>
                    <el-option label="2-新加坡" value="2"></el-option>
                </el-select>
                <el-button type="primary" class="login-button"
                           @click="onSubmit"
                           @keyup.enter.native="enterSubmit">
                    {{$t("homePage.login")}}
                </el-button>
            </div>
            <el-button type="text" class="fullWidth" style="margin-left:0">
                {{$t("homePage.register")}}
            </el-button>
        </div>
    </div>
</template>
<script>
    import {setApiPrefix} from "../../utils/apiUtils";

    export default {
        name: 'homePage',
        data() {
            return {
                isClick: false,
                formData: {
                    entity: "1", // 默认选中股份
                    account: "",
                    passWord: ""
                },
                responseCode: ""
            }
        },
        computed: {},
        watch: {
            // 监听主体选择变化，保存用户偏好
            'formData.entity'(newValue) {
                if (newValue) {
                    this.saveEntityPreference(newValue);
                    sessionStorage.setItem("ENTITY_TYPE", newValue);
                    setApiPrefix(newValue);
                    console.log("切换主体：", newValue);
                }
            }
        },
        created() {
            this.enterSubmit();
            this.checkEntityStatus();
        },
        methods: {
            /************************************ 主体管理 ************************************
             * 根据主体设置API前缀
             */
            setApiPrefix(entity) {
                this.$apiUtils.setApiPrefix(entity);
            },
            /**
             * 保存用户主体选择到localStorage
             */
            saveEntityPreference(entity) {
                if (entity && (entity === "1" || entity === "2")) {
                    localStorage.setItem("USER_ENTITY_PREFERENCE", entity);
                }
            },
            /**
             * 检查主体状态，如果已登录但没有主体信息则清空登录状态
             */
            checkEntityStatus() {
                const accountCode = sessionStorage.getItem("ACCOUNT_CODE");
                const entityType = this.$apiUtils.getCurrentEntity();
                
                // 如果已登录但没有主体信息，清空登录状态
                if (accountCode && !entityType) {
                    sessionStorage.setItem("ACCOUNT_CODE", "");
                    sessionStorage.setItem("COMPANY_CODE", "");
                    this.$apiUtils.clearEntityStatus();
                    sessionStorage.removeItem("permissionList");
                    this.$store.state.permissionList = [];
                }
                
                // 优先从session获取主体信息，如果没有则从localStorage获取用户之前的选择
                if (entityType) {
                    this.formData.entity = entityType;
                } else {
                    const savedEntity = localStorage.getItem("USER_ENTITY_PREFERENCE");
                    if (savedEntity && (savedEntity === "1" || savedEntity === "2")) {
                        this.formData.entity = savedEntity;
                    }
                    // 如果都没有，使用默认值"1"（股份）
                    this.formData.entity = "1";
                }
            },
            /************************************ 登录 ************************************
             * 按钮点击登录
             */
            onSubmit() {
                if (this.isClick) {
                    return;
                }
                if (this.formData.entity === "") {
                    this.showMessage(false, "请选择主体", "warning");
                    return
                }
                if (this.formData.account === "") {
                    this.showMessage(false, this.$t("message.account"), "warning");
                    return
                }
                if (this.formData.passWord === "") {
                    this.showMessage(false, this.$t("message.passWord"), "warning");
                    return
                }
                this.isClick = true;
                
                // 先设置主体状态，这样拦截器就能正确选择后端服务
                this.setApiPrefix(this.formData.entity);
                
                //调用后端登录API
                this.axios({
                    method: 'post',
                    url: '/api/user/login',
                    data: {
                        customerName: this.formData.account,
                        password: this.formData.passWord
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        //获取登录账号及所属客户公司代码，存入session中
                        sessionStorage.setItem("ACCOUNT_CODE", response.data.object.customerName === null ?
                            "" : response.data.object.customerName.toString());
                        sessionStorage.setItem("COMPANY_CODE", response.data.object.companyNameCn === null ?
                            "" : response.data.object.companyNameCn.toString());
                        // 主体状态已在调用API前设置，这里只需要确保存储到session
                        sessionStorage.setItem("ENTITY_TYPE", this.formData.entity);
                        // 保存用户主体选择偏好
                        this.saveEntityPreference(this.formData.entity);
                        this.afterLoginSucceed();
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                        if (response.data.backCode === "203") {//登录账号错误
                            this.formData.entity = "";
                            this.formData.account = "";
                            this.formData.passWord = "";
                        }
                        if (response.data.backCode === "204") {//登录密码错误
                            this.formData.passWord = "";
                        }
                        sessionStorage.setItem("ACCOUNT_CODE", "");
                        sessionStorage.setItem("COMPANY_CODE", "");
                        this.$apiUtils.clearEntityStatus();
                    }
                    this.isClick = false;
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.formData.entity = "";
                    this.formData.account = "";
                    this.formData.passWord = "";
                    this.$apiUtils.clearEntityStatus();
                    this.isClick = false;
                });

                this.$parent.updateHeaderAside();
            },
            /**
             * 回车键登录
             */
            enterSubmit() {
                document.onkeydown = e => {
                    //13表示回车键，baseURI是当前页面的地址
                    if (e.keyCode === 13 && e.target.baseURI.match(/homePage/)) {
                        this.onSubmit()
                    }
                }
            },
            /**
             * 成功登录后：更新缓存中的用户权限数据，跳转页面
             */
            afterLoginSucceed(){
                this.axios({
                    method: 'post',
                    url: '/api/elineFunction/getAllFunctionByLoginUser',
                    headers: {
                        'Content-type': 'application/json',
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    if (response.data.backCode === "200") {
                        // 获取成功,将功能权限信息缓存到session中
                        sessionStorage.setItem("permissionList",JSON.stringify(response.data.object));
                        // 将功能权限信息缓存到vuex中
                        this.$store.state.permissionList = response.data.object;

                        // 控制页面跳转
                        if (this.$route.query.redirect) {
                            let redirect = this.$route.query.redirect;
                            this.checkPermission(redirect);
                        } else {
                            this.checkPermission('/order');
                        }
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 校验当前登录用户是否拥有某个路由的访问权限
             */
            checkPermission(urlRouter){
                let hasPermission = false;
                let urlRouterFinal = null;
                if(sessionStorage.getItem("permissionList")){
                    let permissionList = JSON.parse(sessionStorage.getItem("permissionList"));
                    permissionList.forEach((func)=>{
                        if(urlRouterFinal == null
                            && func.urlRouter != "/homePage"// 排除掉首页
                            && func.urlRouter != "/track"// 排除掉货物跟踪
                            && func.hasPermission){
                            urlRouterFinal = this.getFirstChild(func);
                        }
                        if(func.urlRouter == urlRouter && func.hasPermission){
                            hasPermission = true;
                        }
                    })
                }
                if(!hasPermission){
                    this.$router.push(urlRouterFinal)
                } else{
                    this.$router.push(urlRouter)
                }
            },
            getFirstChild(func){
                if(func.childrenFunctionList && func.childrenFunctionList.length){
                    return this.getFirstChild(func.childrenFunctionList[0]);
                } else{
                    return func.urlRouter;
                }

            }
        },
        mounted() {}
    }
</script>
<style lang="scss" scoped>
    @import "../../assets/scss/base.scss";
    @import "../../assets/scss/public.scss";

    .homePage {
        position: relative;
        width: 100%;
        //   height: calc(100vh - 126px);
        //   background: url("../../assets/image/bg.jpg");
        img {
            width: 100%;
            height: 100%;
        }

        .homePage-right {
            position: fixed;
            width: 30%;
            background: rgba(255, 255, 253, 0.6);
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            right: 5%;
            top: 20%;
            padding: 31px 50px;

            .h3 {
                color: $colorC;
                border-bottom: 3px $colorC solid;
                font-size: $fontE;
                line-height: 25px;
                font-weight: 700;
            }

            /deep/ .el-input, /deep/ .el-select {
                height: 56px;
                line-height: 56px;
                background: #ffffff;
                box-shadow: 0px 0px 4px 0px rgba(2, 31, 78, 1);
                border-radius: 3px;
            }

            /deep/ .el-input__inner, /deep/ .el-select .el-input__inner {
                height: 100%;
                line-height: 100%;
                border: none;
                font-size: $fontB;
                padding-left: 40px;
            }

            /deep/ .el-input__prefix, /deep/ .el-select .el-input__prefix {
                left: 10px;
            }
        }

        .form-item-first {
            margin: 35px 0;
        }

        .icon {
            color: $colorC;
            font-size: 18px;
        }

        .font-weight {
            text-align: right;
            width: 100%;
        }

        .login-row {
            display: flex;
            gap: 10px;
            margin-bottom: 10px;
        }

        .entity-select {
            flex: 0 0 65%;
            height: 60px;
        }

        .login-button {
            flex: 0 0 35%;
            height: 60px;
            font-size: 20px;
            font-weight: 600;
        }

        /deep/ .entity-select .el-input {
            height: 60px;
            line-height: 60px;
            background: #ffffff;
            box-shadow: 0px 0px 4px 0px rgba(2, 31, 78, 1);
            border-radius: 3px;
        }

        /deep/ .entity-select .el-input__inner {
            height: 100%;
            line-height: 100%;
            border: none;
            font-size: $fontB;
            padding-left: 40px;
        }

        /deep/ .entity-select .el-input__prefix {
            left: 10px;
        }
    }
</style>